export const ENCORE_SCRIPT_MAP = {
  heycar: '18187',
  rac: '18188',
};
